<template>
  <van-popup
      class="showArea"
      v-model="showArea"
      round
      closeable
      close-icon="close"
      position="bottom"
      :style="{ height: '80%' }"
      @closed="onAreaClosed"
  >
    <div class="showArea-title">配送至</div>
    <div class="area-con">
      <div class="area-con-header">
        <div class="item-con">
          <div class="item" :class="{active: (areaConData.areaLevelTab===1)}" @click="changeAreaLevel(1)">{{ areaConData.areaText1 }}</div>
          <div class="item" :class="{active: (areaConData.areaLevelTab===2)}" v-if="areaConData.areaText2" @click="changeAreaLevel(2)">{{ areaConData.areaText2 }}</div>
          <div class="item" :class="{active: (areaConData.areaLevelTab===3)}" v-if="areaConData.areaText3" @click="changeAreaLevel(3)">{{ areaConData.areaText3 }}</div>
          <div class="item" :class="{active: (areaConData.areaLevelTab===4)}" v-if="areaConData.areaText4" @click="changeAreaLevel(4)">{{ areaConData.areaText4 }}</div>
        </div>
      </div>
      <div class="list-con">
        <div class="areaLevel1" v-show="areaConData.areaLevelTab===1">
          <div class="item" v-for="(item, i) in areaConData.areaLevel1" :key="'areaId-'+item.areaId" @click="areaLevelChange(1, i, item)">
            <div class="text">{{ item.areaName }}</div>
            <div class="active-icon" v-if="areaConData.areaIdActive1===item.areaId"></div>
          </div>
        </div>
        <div class="areaLevel2" v-show="areaConData.areaLevelTab===2">
          <div class="item" v-for="(item, i) in areaConData.areaLevel2" :key="'areaId-'+item.areaId" @click="areaLevelChange(2, i, item)">
            <div class="text">{{ item.areaName }}</div>
            <div class="active-icon" v-if="areaConData.areaIdActive2===item.areaId"></div>
          </div>
        </div>
        <div class="areaLevel3" v-show="areaConData.areaLevelTab===3">
          <div class="item" v-for="(item, i) in areaConData.areaLevel3" :key="'areaId-'+item.areaId" @click="areaLevelChange(3, i, item)">
            <div class="text">{{ item.areaName }}</div>
            <div class="active-icon" v-if="areaConData.areaIdActive3===item.areaId"></div>
          </div>
        </div>
        <div class="areaLevel4" v-show="areaConData.areaLevelTab===4">
          <div class="item" v-for="(item, i) in areaConData.areaLevel4" :key="'areaId-'+item.areaId" @click="areaLevelChange(4, i, item)">
            <div class="text">{{ item.areaName }}</div>
            <div class="active-icon" v-if="areaConData.areaIdActive4===item.areaId"></div>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { areaList } from '@/api/mall/mallLogistics'

export default {
  components: {
  },
  props: {
    show: {
      required: false
    },
    editArea: {
      required: false,
      default:()=>{
        return {
          countryAreaId: 0,
          provinceAreaId: 0,
          cityAreaId: 0,
          countyAreaId: 0,
          townAreaId: 0,
        }
      }
    }
  },
  data(){
    return {
      areaIds: {},
      showArea: false,
      areaConData: {
        areaLevel1: [],//省级数据
        areaLevel2: [],//市级数据
        areaLevel3: [],//县级数据
        areaLevel4: [],//街道级数据
        areaText1: '请选择',//标签页显示文字
        areaText2: '',//标签页显示文字
        areaText3: '',//标签页显示文字
        areaText4: '',//标签页显示文字
        areaLevelTab:1,//标签页
        areaIdActive1: '',//已经选中的 省级
        areaIdActive2: '',//已经选中的 市级
        areaIdActive3: '',//已经选中的 县级
        areaIdActive4: '',//已经选中的 街道级
        area1: null,//已经选中的 省级
        area2: null,//已经选中的 市级
        area3: null,//已经选中的 县级
        area4: null,//已经选中的 街道级
        currAreaId1: '',//当前点击选中的 省级
        currAreaId2: '',//当前点击选中的 市级
        currAreaId3: '',//当前点击选中的 县级
        currAreaId4: '',//当前点击选中的 街道级
      }
    }
  },
  watch: {
    show(val){
      this.showArea = val
    },
    editArea(val){
      this.areaIds = val
      this.areaIdsChange()
    },
  },
  created(){
    if(!this.$route.query.userAddressId){ // 新增时才调用
      this.getAreaList({areaId: 0})
    }

  },
  methods: {

    getAreaList(req){
      let isEdit = this.$route.query.userAddressId;
      areaList(req).then(res=>{
        if(res.code===200){
          let data = res.data || [];
          if(data.length){
            this.areaConData['areaLevel'+data[0].areaLevel] = data
            if(isEdit){// 编辑时
              if(data[0].areaLevel===1){
                this.areaConData.areaIdActive1 = this.editArea.provinceAreaId
                for(let i=0; i<data.length; i++){
                  if(data[i].areaId === this.editArea.provinceAreaId){
                    this.areaConData.area1 = data[i]
                    this.areaConData.areaText1 = data[i].areaName
                    break;
                  }
                }
              }
              if(data[0].areaLevel===2){
                this.areaConData.areaIdActive2 = this.editArea.cityAreaId
                for(let i=0; i<data.length; i++){
                  if(data[i].areaId === this.editArea.cityAreaId){
                    this.areaConData.area2 = data[i]
                    this.areaConData.areaText2 = data[i].areaName
                    break;
                  }
                }
              }
              if(data[0].areaLevel===3){
                this.areaConData.areaIdActive3 = this.editArea.countyAreaId
                for(let i=0; i<data.length; i++){
                  if(data[i].areaId === this.editArea.countyAreaId){
                    this.areaConData.area3 = data[i]
                    this.areaConData.areaText3 = data[i].areaName
                    window.setTimeout(()=>{
                      this.areaConData.areaLevelTab = 3
                    },150)
                    break;
                  }
                }
              }
              if(data[0].areaLevel===4){
                this.areaConData.areaIdActive4 = this.editArea.townAreaId
                for(let i=0; i<data.length; i++){
                  if(data[i].areaId === this.editArea.townAreaId){
                    this.areaConData.area4 = data[i]
                    this.areaConData.areaText4 = data[i].areaName
                    window.setTimeout(()=>{
                      this.areaConData.areaLevelTab = 4
                    },200)
                    break;
                  }
                }
              }





            }
          }else {
            if(this.areaConData.areaLevelTab>1){
              this.areaConData.areaLevelTab--
            }
          }
        }
      })
    },
    // 点击地区
    areaLevelChange(areaLevel, i, item){
      // console.log(areaLevel, i, item)
      this.areaConData.areaLevelTab = areaLevel;
      this.areaConData['area'+areaLevel] = item;
      this.areaConData['currAreaId'+areaLevel] = item.areaId;

      if(this.areaConData['currAreaId'+areaLevel] === this.areaConData['areaIdActive'+areaLevel]){ // 当前点击地区 跟 已选地区 是否相同
        switch(areaLevel){
          case 1:
            this.areaConData.areaLevel2.length && (this.areaConData.areaLevelTab=2);
            break;
          case 2:
            this.areaConData.areaLevel3.length && (this.areaConData.areaLevelTab=3);
            break;
          case 3:
            this.areaConData.areaLevel4.length && (this.areaConData.areaLevelTab=4);
            break;
          default:
            break;
        }
      }else {
        this.areaConData['areaIdActive'+areaLevel] = item.areaId;
        this.areaConData['areaText'+areaLevel] = item.areaName;
        if(areaLevel<4){
          this.getAreaList({areaId: item.areaId})//拉取下级数据
        }
        switch(areaLevel){
          case 1:
            this.areaConData.areaText2 = ''
            this.areaConData.areaText3 = ''
            this.areaConData.areaText4 = ''
            this.areaConData.areaIdActive2 = 0
            this.areaConData.areaIdActive3 = 0
            this.areaConData.areaIdActive4 = 0
            this.areaConData.area2 = null
            this.areaConData.area3 = null
            this.areaConData.area4 = null
            this.areaConData.areaLevel2 = []
            this.areaConData.areaLevel3 = []
            this.areaConData.areaLevel4 = []
            this.areaConData.areaLevelTab = 2
            break;
          case 2:
            this.areaConData.areaText3 = ''
            this.areaConData.areaText4 = ''
            this.areaConData.areaIdActive3 = 0
            this.areaConData.areaIdActive4 = 0
            this.areaConData.area3 = null
            this.areaConData.area4 = null
            this.areaConData.areaLevel3 = []
            this.areaConData.areaLevel4 = []
            this.areaConData.areaLevelTab = 3
            break;
          case 3:
            this.areaConData.areaText4 = ''
            this.areaConData.areaIdActive4 = 0
            this.areaConData.area4 = null
            this.areaConData.areaLevel4 = []
            this.areaConData.areaLevelTab = 4
            break;
          case 4:
            this.areaConData.areaLevelTab = 4
            break;
          default:
            break;
        }
      }
      let showAreaText = `${this.areaConData.areaText1} ${this.areaConData.areaText2} ${this.areaConData.areaText3} ${this.areaConData.areaText4}`;
      this.$emit('onChange', showAreaText)
    },

    changeAreaLevel(i){
      this.areaConData.areaLevelTab = i
    },
    onAreaClosed(){
      let data = {
        area1: this.areaConData.area1,//已经选中的 省级
        area2: this.areaConData.area2,//已经选中的 市级
        area3: this.areaConData.area3,//已经选中的 县级
        area4: this.areaConData.area4,//已经选中的 街道级
      }
      this.$emit('onClose', data)
    },


    areaIdsChange(){
      // console.log(this.areaIds)
      if(this.areaIds.countryAreaId!==''){//国级-->省级
        this.getAreaList({areaId: this.areaIds.countryAreaId})
      }
      if(this.areaIds.provinceAreaId){//省级-->市级
        this.getAreaList({areaId: this.areaIds.provinceAreaId})
      }
      if(this.areaIds.cityAreaId){//市级-->县级
        this.getAreaList({areaId: this.areaIds.cityAreaId})
      }
      if(this.areaIds.countyAreaId){//县级-->街道
        this.getAreaList({areaId: this.areaIds.countyAreaId})
      }

    },

  }
}
</script>

<style lang="less" scoped>
.showArea{
  .showArea-title{
    font-size: 18px;font-weight: bold;color: #333;
    padding: 15px 12px 5px;
  }
  .area-con{
    position: absolute;top: 54px;bottom: 0;left: 0;right: 0;
    font-size: 14px;color: #333;
    .area-con-header{
      width: 100%;height: 30px;padding-right: 12px;overflow: hidden;
      .item-con{
        display: flex;padding-bottom: 12px;
        overflow-x: auto;overflow-y: hidden;
        .item{
          display: inline-flex;height: 30px;padding: 0 12px;flex-shrink: 0;
          &.active{
            color: #1585f3;
          }
        }
      }

    }
  }
  .list-con{
    position: absolute;top: 30px;bottom: 0;left: 0;right: 0;
    padding: 0 12px 12px;overflow-y: auto;
    .item{
      height: 38px;
      display: flex;align-items: center;
      .text{padding-right: 8px;}
      .active-icon{
        display: inline-flex;
        width: 22px;height: 100%;
        background: url("./img/check-icon.png") no-repeat 50% 50%;
        background-size: 15px 9px;
      }
    }
  }
}
</style>